import React from 'react';
import { Search, Phone } from 'lucide-react';
import { PHONE_NUMBER, PHONE_TEL_HREF } from '../../constants/site';

export const QuickSearchForm = ({ query, setQuery, onSubmit }) => (
  <div className="p-5 bg-gradient-to-br from-gray-50 to-white">
    <form onSubmit={onSubmit}>
      <div className="flex items-center bg-sand-50 rounded-xl border-2 border-gray-200 focus-within:border-[#143160] overflow-hidden shadow-sm">
        <input
          data-testid="nav-search-input"
          type="text"
          placeholder="City, ZIP, or Address..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="flex-1 px-4 py-3 bg-transparent text-gray-800 placeholder-gray-400 text-sm focus:outline-none"
          autoFocus
        />
        <button type="submit" data-testid="nav-search-submit" className="px-4 py-3 bg-[#143160] text-white hover:bg-[#1E4A86] transition-colors"><Search className="w-5 h-5" /></button>
      </div>
    </form>
  </div>
);

const ItemIcon = ({ item }) => {
  if (item.nested) return <span className="w-8 flex justify-center"><span className="w-1.5 h-1.5 rounded-full bg-gold-500" /></span>;
  const Icon = item.icon;
  return <div className="w-8 h-8 bg-[#143160]/10 rounded-lg flex items-center justify-center"><Icon className="w-4 h-4 text-[#143160]" /></div>;
};

export const QuickSearchItem = ({ item, onNavigate }) => {
  const cls = `w-full flex items-center space-x-3 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-gold-100 hover:to-transparent hover:text-[#143160] transition-all ${item.nested ? 'pl-10 pr-5 text-sm' : 'px-5'}`;
  const inner = <><ItemIcon item={item} /><span className="font-medium">{item.label}</span></>;
  if (item.type === 'scroll') {
    return <button onClick={() => { item.action(); onNavigate(); }} className={`${cls} text-left`}>{inner}</button>;
  }
  return (
    <a href={item.href} target={item.internal ? undefined : '_blank'} rel={item.internal ? undefined : 'noopener noreferrer'} onClick={onNavigate} className={cls}>{inner}</a>
  );
};

export const QuickSearchCallBar = () => (
  <div className="p-4 bg-gradient-to-r from-[#143160] to-[#1E4A86]">
    <a href={PHONE_TEL_HREF} className="flex items-center justify-center space-x-2 text-white font-bold hover:text-gold-400 transition-colors">
      <Phone className="w-5 h-5" /><span>Call Jess: {PHONE_NUMBER}</span>
    </a>
  </div>
);
